// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedExternalIdModel {
    static getAttributeTypeMap() {
        return SiteSharedExternalIdModel.attributeTypeMap;
    }
}
SiteSharedExternalIdModel.discriminator = undefined;
SiteSharedExternalIdModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    }
];
//# sourceMappingURL=siteSharedExternalIdModel.js.map